<template>
  <div class="evolucion-plazos-pago">
    <div class="dashboard-chart">
      <h4>Evolución de Plazos de Pago</h4>
    </div>
    <bar-evolucion
      chartId="bar-evolucion-plazos-pag" 
      class="chart-wrapper"
      ref="evolucionPlazosPago"
      :stepSize="parseInt(5)"
      :max="parseInt(90)"
      :yAxisCurrency="false">
    </bar-evolucion>

  <div class="dashboard-tabla-resultados">
    <div class="dashboard-tabla-resultados-data">
        <b-table hover
            responsive="sm" 
            class="table-dashboard"
            :busy="tableBusy"
            :items="resultadosEvolucion" 
            :fields="fields">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>              
          <template v-slot:cell(periodo)="data">
            {{ data.item.periodo | periodo }}
          </template>
          <template v-slot:cell(plazoPromedio)="data">
            {{ data.item.plazoPromedio | numero(2, true) }}
          </template>
          <template v-slot:cell(opciones)="data">
            <b-dropdown 
                variant="link" toggle-class="text-decoration-none" no-caret>
              <template slot="button-content">
                <i class="fa fa-ellipsis-v"></i>
              </template>

              <b-dropdown-item 
                  @click.stop="exportarComprobantes(data.item)">
                <i class="fa fa-file-excel-o"></i>Exportar Comprobantes</b-dropdown-item>
            </b-dropdown>
          </template>
        </b-table>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import BarEvolucion from '../../charts/Bar.vue';
import Mensaje from  '../../shared/msjModal.vue';
import { msjModal } from '../../../mixins/modalDialogs'

export default {
  name: 'DashboardEvolucionPlazosPago',
  components: {
    BarEvolucion,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      resultadosEvolucion: [],

      fields: [
        { key: 'periodo' },
        {
          key: 'plazoPromedio',
          class: 'text-right',
        },
        { 
          key: 'opciones',
          label: '',
          class: 'text-center'
        },
      ],

      tableBusy: false,
    }
  },
  methods: {
    getEvolucion() {
      this.$store.dispatch('resultadosAdministracion/getEvolucionPlazosPago')
        .then(() => {
          this.$refs.evolucionPlazosPago.render(this.$store.getters['resultadosAdministracion/resultadosEvolucionPlazosPagoPeriodos'], 
            this.$store.getters['resultadosAdministracion/resultadosEvolucionPlazosPagoBarras'],
            parseInt(5),
            parseInt(60),
            parseInt(45));

          this.resultadosEvolucion = this.$store.getters['resultadosAdministracion/resultadosEvolucionPlazosPago'];
        })
        .catch(error => {
          console.log(error);
          // this.showErrorMsj(error)
        });
    },
    exportarComprobantes(periodo) {
      let params = {
        fechaDesde: periodo.fechaDesde,
        fechaHasta: periodo.fechaHasta
      }
      this.showSpinner();
      this.$store.dispatch('resultadosAdministracion/getEvolucionPlazosPagoComprobantes', params)
        .then(() => {
          let exportRpt = Boolean(false); 
          let rptComprobantes = this.$store.getters['resultadosAdministracion/resultados'];

          if (rptComprobantes) {
            if (rptComprobantes.length != 0) {
              exportRpt = Boolean(true);
            }
          }
          if (exportRpt) {
            this.exportXLSResumenPlazosProveedores(rptComprobantes);
          } else {
            console.log('No hay datos para exportar.');
            // this.showErrorMsj('No hay datos para exportar.')
          }
        })
        .catch(error => {
          console.log(error);
          // this.showErrorMsj(error)
        })
        .finally(() => this.hideSpinner());
    }

    // drawObjectiveLine(chart) {
    //   console.log('drawObjectiveLine');

    //   const ctx = chart.chart.ctx;
    //   const yAxis = chart.scales['y-axis-0'];
    //   const xAxis = chart.scales['x-axis-0'];
      
    //   const yPosition = yAxis.getPixelForValue(45);

    //   console.log(yPosition);
      
    //   ctx.save();
    //   ctx.strokeStyle = 'red';
    //   ctx.lineWidth = 2;
    //   ctx.setLineDash([5, 5]);
    //   ctx.beginPath();
    //   ctx.moveTo(xAxis.left, yPosition);
    //   ctx.lineTo(xAxis.right, yPosition);
    //   ctx.stroke();
    //   ctx.restore();
    // }    
  },
  watch: {
  },
}
</script>

<style>
  .evolucion-plazos-pago .chart-wrapper {
    position: relative;
    height: 350px;
    margin-bottom: 30px;
  }
  .evolucion-plazos-pago .dashboard-tabla-resultados-data {
    min-height: 0 !important;
  }

  .evolucion-plazos-pago .dashboard-chart h4 {
    margin-bottom: 5px;
  }
  .evolucion-plazos-pago .dashboard-chart p.description label {
    font-size: 1em;
    font-style: italic;
    cursor: pointer;
    margin-bottom: 5px;    
  }
  .evolucion-plazos-pago .dashboard-chart p.description .custom-checkbox .custom-control-label::before {
    height: 12px;
    width: 12px;
    left: -20px;    
  }
  .evolucion-plazos-pago .dashboard-chart p.description .custom-checkbox .custom-control-label::after {
    top: 0.08rem;
    left: -1.35rem;    
  }

  .evolucion-plazos-pago .table-dashboard table td[aria-colindex="1"] {
    width: calc(90% - 45px);
  }
  .evolucion-plazos-pago .table-dashboard table td[aria-colindex="2"] {
    width: 10%;
  }
  .evolucion-plazos-pago .table-dashboard table td[aria-colindex="3"] {
    width: 45px;
  }

</style>
